import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4" }, "Interessentfassung wird geladen", -1)

import {nextTick, ref, watch} from 'vue';
import ErrorComp from '@/components/Error.vue';
import router from '@/router';
import {doAlert} from '@/util';
import Provider, {
  ApiInteressentSubmitData,
  ApiOutgoingPostAddress,
} from '@/model/Provider';
import {postProvider} from '@/api/module/provider';
import moment from 'moment';
import type {Nullable} from '@/util';
import SelectNationality from '@/components/SelectNationality.vue';
import {useStorage} from '@/composables/storage';
import useDetailProviderStore from '@/store/detailProvider';
import {VNodeRef} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerInteressentCreate',
  setup(__props, { expose: __expose }) {

const defaultAddress: Nullable<ApiOutgoingPostAddress> & { Anrede: string } = {
  Anrede: 'Herr',
  Briefanrede: 'Sehr geehrte Damen und Herren',
  Frei1: null,
  Frei2: null,
  Frei3: null,
  Frei4: null,
  LangName1: null,
  LangName2: null,
  LangName3: null,
  Name1: null,
  Name2: null,
  Name3: null,
  Strasse: null,
  Plz: null,
  Ort: null,
  NAT: null,
  Postfach: null,
  PostfachPlz: null,
  PostfachOrt: null,
  Telefon1: null,
  Telefon2: null,
  Telefax: null,
  Email: null,
  Homepage: null,
};

const store = useDetailProviderStore();

useStorage(
    store,
    () => 'Interessent anlegen',
    (route) => {
      return {
        KundenNr: parseInt(Array.isArray(route.params.id) ? route.params.id[0] : route.params.id),
      };
    },
);

const submitting = ref(false);
const postAddress = ref(structuredClone(defaultAddress));
const billingAddress = ref(structuredClone(defaultAddress));
const customer = ref({
  ErstellDatum: '',
  Kundname: '',
  Gebiet: null,
  ZahlungsBedingungen: {
    SkontoTage1: null,
    SkontoProzent1: null,
    SkontoTage2: null,
    SkontoProzent2: null,
    NettoTage: null,
    Text: '',
  },
  BetriebsNr: null,
  UStId: null,
  Steuernummer: null,
  PostAnschrift: [],
  RechnungAnschrift: [],
});
const formValid = ref(false);
const form = ref<HTMLFormElement & VNodeRef | undefined>();

async function save() {
  try {
    submitting.value = true;
    form.value?.validate();
    if (!formValid.value) {
      throw new Error('Bitte alle Felder korrekt ausfüllen');
    }
    customer.value.ErstellDatum = moment().toISOString();
    const billingAddressProvided = Object.entries(billingAddress.value).some(
        ([key, value]) => {
          return value && key !== 'Briefanrede' && key !== 'Anrede';
        },
        false,
    );
    const postProviderData: ApiInteressentSubmitData = {
      ...customer.value,
      Staat: postAddress.value.NAT,
      Kundname: postAddress.value.Name1!,
      PostAnschrift: [postAddress.value as ApiOutgoingPostAddress],
    };
    if (billingAddressProvided) postProviderData.RechnungAnschrift = [billingAddress.value as ApiOutgoingPostAddress];
    await postProvider(postProviderData);
    router.back();
    // router.push({
    //   name: 'customer_details',
    //   params: {customer_id: responseCustomer.KundenNr.toString()},
    // });
  } catch (err: any) {
    await doAlert(err.message, 'Fehler');
  } finally {
    submitting.value = false;
  }
};
function ruleRequired(val: string | null | undefined): string | true {
  if (!val) return 'erforderlich';

  return true;
}
function ruleEmailValid(val: string | null | undefined): string | true {
  return (
    !val ||
        /^[a-z0-9!#$%&'*+/=?^_'{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_'{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(val) ||
        'E-Mail muss gültig sein'
  );
}
function ruleNumber(val: string | null | undefined): string | true {
  return !val || /^\d+$/.test(val) || 'muss Nummer sein';
}
function rulePhoneNumber(val: string | null | undefined): string | true {
  return (
    !val ||
        /^\+?[() /\-0-9]+$/.test(val) ||
        'Telefonnummer ungültig'
  );
}
function ruleMaxLen(len: number) {
  return (val: string | null | undefined): string | true => {
    if (typeof val !== 'string') return true;
    return val.length <= len || `maximal ${len} Zeichen`;
  };
}

watch(() => store.data, async (data: Provider | null) => {
  if (data) {
  }
  await nextTick();
  form.value?.validate();
});
watch(form, () => {
  form.value?.validate();
});

__expose({
  store,
  save,
  ruleRequired,
  ruleEmailValid,
  ruleNumber,
  rulePhoneNumber,
  ruleMaxLen,
  submitting,
  postAddress,
  billingAddress,
  customer,
  formValid,
  form,
  Error: ErrorComp, SelectNationality,
});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_error = _resolveComponent("error")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_unref(store).loading && !_unref(store).error)
      ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_v_form, {
              modelValue: formValid.value,
              "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((formValid).value = $event)),
              ref: form.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_text_field, {
                  modelValue: postAddress.value.Name1,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((postAddress.value.Name1) = $event)),
                  rules: [ruleMaxLen(30)],
                  label: "Name 1"
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: postAddress.value.Name2,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((postAddress.value.Name2) = $event)),
                  rules: [ruleMaxLen(30)],
                  label: "Name 2"
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: postAddress.value.Name3,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((postAddress.value.Name3) = $event)),
                  rules: [ruleMaxLen(40)],
                  label: "Branche (Name 3)"
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: postAddress.value.Strasse,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((postAddress.value.Strasse) = $event)),
                  rules: [ruleMaxLen(42)],
                  label: "Straße"
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: postAddress.value.Plz,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((postAddress.value.Plz) = $event)),
                  label: "PLZ",
                  rules: [ruleMaxLen(10)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: postAddress.value.Ort,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((postAddress.value.Ort) = $event)),
                  rules: [ruleMaxLen(40)],
                  label: "Ort"
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(SelectNationality, {
                  modelValue: postAddress.value.NAT,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((postAddress.value.NAT) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  modelValue: postAddress.value.Telefon1,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((postAddress.value.Telefon1) = $event)),
                  label: "Telefon",
                  rules: [rulePhoneNumber, ruleMaxLen(20)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: postAddress.value.Telefon2,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((postAddress.value.Telefon2) = $event)),
                  label: "Mobil",
                  rules: [rulePhoneNumber, ruleMaxLen(20)]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_text_field, {
                  modelValue: postAddress.value.Telefax,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((postAddress.value.Telefax) = $event)),
                  label: "Telefax"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_v_text_field, {
                  modelValue: postAddress.value.Email,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((postAddress.value.Email) = $event)),
                  label: "E-Mail",
                  rules: [ruleEmailValid]
                }, null, 8, ["modelValue", "rules"]),
                _createVNode(_component_v_expansion_panels, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(" Weitere Informationen ")
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: customer.value.BetriebsNr,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((customer.value.BetriebsNr) = $event)),
                              label: "Betriebs-Nr.",
                              rules: [ruleMaxLen(15)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: customer.value.UStId,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((customer.value.UStId) = $event)),
                              label: "USt-ID",
                              rules: [ruleMaxLen(15)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: customer.value.Steuernummer,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((customer.value.Steuernummer) = $event)),
                              label: "Steuernummer",
                              rules: [ruleMaxLen(50)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: postAddress.value.Homepage,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((postAddress.value.Homepage) = $event)),
                              label: "Homepage",
                              rules: [ruleMaxLen(60)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: customer.value.Gebiet,
                              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((customer.value.Gebiet) = $event)),
                              label: "Gebiet",
                              rules: [ruleMaxLen(30)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: postAddress.value.Postfach,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((postAddress.value.Postfach) = $event)),
                              label: "Postfach",
                              rules: [ruleNumber, ruleMaxLen(10)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: postAddress.value.PostfachPlz,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((postAddress.value.PostfachPlz) = $event)),
                              label: "Postfach PLZ",
                              rules: [ruleMaxLen(8)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: postAddress.value.PostfachOrt,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((postAddress.value.PostfachOrt) = $event)),
                              label: "Postfach Ort",
                              rules: [ruleMaxLen(30)]
                            }, null, 8, ["modelValue", "rules"])
                          ], undefined, true),
                          _: 1
                        })
                      ], undefined, true),
                      _: 1
                    }),
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(" Rechnungsanschrift ")
                          ], undefined, true),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              modelValue: billingAddress.value.Name1,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((billingAddress.value.Name1) = $event)),
                              label: "Name 1",
                              rules: [ruleMaxLen(30)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: billingAddress.value.Name2,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((billingAddress.value.Name2) = $event)),
                              label: "Name 2",
                              rules: [ruleMaxLen(30)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: billingAddress.value.Name3,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((billingAddress.value.Name3) = $event)),
                              label: "Branche (Name 3)",
                              rules: [ruleMaxLen(40)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: billingAddress.value.Strasse,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((billingAddress.value.Strasse) = $event)),
                              label: "Straße",
                              rules: [ruleMaxLen(42)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: billingAddress.value.Plz,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((billingAddress.value.Plz) = $event)),
                              label: "PLZ",
                              rules: [ruleMaxLen(10)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: billingAddress.value.Ort,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((billingAddress.value.Ort) = $event)),
                              label: "Ort",
                              rules: [ruleMaxLen(40)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(SelectNationality, {
                              modelValue: billingAddress.value.NAT,
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((billingAddress.value.NAT) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: billingAddress.value.Telefon1,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((billingAddress.value.Telefon1) = $event)),
                              label: "Telefon",
                              rules: [rulePhoneNumber, ruleMaxLen(20)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: billingAddress.value.Telefon2,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((billingAddress.value.Telefon2) = $event)),
                              label: "Mobil",
                              rules: [rulePhoneNumber, ruleMaxLen(20)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: billingAddress.value.Telefax,
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((billingAddress.value.Telefax) = $event)),
                              label: "Telefax",
                              rules: [ruleMaxLen(20)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: billingAddress.value.Email,
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((billingAddress.value.Email) = $event)),
                              label: "E-Mail",
                              rules: [ruleEmailValid]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: billingAddress.value.Postfach,
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((billingAddress.value.Postfach) = $event)),
                              label: "Postfach",
                              rules: [ruleNumber, ruleMaxLen(10)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: billingAddress.value.PostfachPlz,
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((billingAddress.value.PostfachPlz) = $event)),
                              label: "Postfach PLZ",
                              rules: [ruleMaxLen(8)]
                            }, null, 8, ["modelValue", "rules"]),
                            _createVNode(_component_v_text_field, {
                              modelValue: billingAddress.value.PostfachOrt,
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((billingAddress.value.PostfachOrt) = $event)),
                              label: "Postfach Ort",
                              rules: [ruleMaxLen(30)]
                            }, null, 8, ["modelValue", "rules"])
                          ], undefined, true),
                          _: 1
                        })
                      ], undefined, true),
                      _: 1
                    })
                  ], undefined, true),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  class: "mt-5",
                  color: "primary",
                  onClick: save,
                  disabled: !formValid.value,
                  loading: submitting.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Speichern ")
                  ], undefined, true),
                  _: 1
                }, 8, ["disabled", "loading"])
              ], undefined, true),
              _: 1
            }, 8, ["modelValue"])
          ], undefined, true),
          _: 1
        }))
      : (_unref(store).error)
        ? (_openBlock(), _createBlock(_component_error, {
            key: 1,
            module: _unref(store).$id
          }, null, 8, ["module"]))
        : (_openBlock(), _createBlock(_component_v_overlay, {
            key: 2,
            modelValue: _unref(store).loading,
            "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(store).loading) = $event)),
            class: "align-center justify-center",
            persistent: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, { class: "text-center" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_v_progress_circular, { indeterminate: "" })
                      ]),
                      _hoisted_2
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              })
            ], undefined, true),
            _: 1
          }, 8, ["modelValue"]))
  ]))
}
}

})